const CalenderOptions = [
  {
    label: "Last 30 days",
    value: "last_30_days",
  },
  {
    label: "Today",
    value: "today",
  },
  {
    label: "Yesterday",
    value: "yesterday",
  },
  {
    label: "This Week",
    value: "this_week",
  },
  {
    label: "Last Week",
    value: "last_week",
  },
  {
    label: "Last Month",
    value: "last_month",
  },
  {
    label: "This Month",
    value: "this_month",
  },
  {
    label: "This Year",
    value: "this_year",
  },
  {
    label: "Last Year",
    value: "last_year",
  },
];

export default CalenderOptions;
